import React from 'react';
import Layout from '../components/Layout';
import AboutBanner from '../sections/AboutBanner/AboutBanner';
import Faq from '../sections/Faq/Faq';
import Priority from '../sections/Priority/Priority';
import Safety from '../sections/Safety/Safety';
import Team from '../sections/Team/Team';

const About = () => {
    return (
        <Layout>
            <AboutBanner />
            <Priority />
            {/* <Safety /> */}
            {/* <Team /> */}
            <Faq />
        </Layout>
    );
};

export default About;